module.exports = __webpack_public_path__ + "static/img/ai-close.6b56726b.png";